// extracted by mini-css-extract-plugin
export default {"photo__container":"roundphoto_photo__container__u+oGC","photo":"roundphoto_photo__4LEDA"};